// removed by extract-text-webpack-plugin
module.exports = {"popup":"_1OmtvIf2unFPj-L6aGdsPH","block":"_3b0DHWAzB4QWibEPXrxP_A","open":"_2-b8BPgyUQKNI6ceY4mr_i","image":"_3NSIrxDM31y6r62QmPCd4m","info":"_15yZZSj6BLa7wxu_8JTqZ-"};